// extracted by mini-css-extract-plugin
export default {"notfound_container":"view_notfound_container__v8ZiY","notfound_text1":"view_notfound_text1__McXK5","notfound_text2":"view_notfound_text2__5iJcH"};